<template>
  <div v-if="audit">
    <div class="entete border-entete">
      <div class="is-paddingless section">
        <div class="level">
          <div class="level-left">
            <div class="columns is-gapless">
              <div class="column">
                <h1 class="title is-size-3" >
                  {{ $t('addEditAudit.title.addReseau') }}
                </h1>
                <breadcrumb :breadcrumb="breadcrumb"/>
              </div>
            </div>
          </div>
          <div class="level-right">
            <div class="buttons">
              <button class="button" @click="$router.go(-1)">
                {{$t('general.button.return')}}
              </button>
              <button class="button is-addOrEdit mgl-10px" @click="saveDispositif">
                {{$t('general.button.add')}}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <store-recherche-provider
      name="selectionReseauForAudit"
      :copy="storeProduitReseau"
      :isTemporary="true">
      <liste-reseaux
        :typeReseau="categories"
        :referenceTable="constantes.REFERENCE_TABLE_PRODUIT_RESEAU"
        storeName="selectionReseauForAudit"
        :selection="reseau"
        :isSelection="true"
        @addSelection="addSelect"
        @removeSelection="removeSelect">
      </liste-reseaux>
    </store-recherche-provider>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import breadcrumb from '@/components/general/breadcrumb';
import messageErreur from '@/services/general/messageErreur';
import { SET_AUDIT_COURANT } from '@/store/modules/logistique/audit-mutation-type';
import { DISPOSITIF } from '@/configuration/gabed/emplacement/emplacementConf';
import storeRechercheProvider from '@/components/general/store/storeRechercheProvider';
import listeReseaux from '@/components/catalogue/produitReseau/listeProduitReseau';
import {
  CATEGORIE_REGROUPEMENT,
  CATEGORIE_REGROUPEMENT_LC,
  CATEGORIE_REGROUPEMENT_MAIRIE,
  CATEGORIE_REGROUPEMENT_NUMERIQUE,
} from '@/configuration/catalogue/produitConf';
import { REFERENCE_TABLE_PRODUIT_RESEAU } from '@/configuration/general/referenceTableConf';
import addGenerationOtFromDispositifAudit from '@/services/logistique/audit/addGenerationOtFromDispositifAudit';
import { getAllDispositifFromReseau } from '@/api/produit/produitReseau';
import formatDate from '@/services/general/formatIsoDate';
import storeProduitReseau from '@/store/modules/produitReseau';

const Audit = createNamespacedHelpers('audit');

export default {
  data() {
    return {
      storeProduitReseau,
      constantes: {
        DISPOSITIF,
        REFERENCE_TABLE_PRODUIT_RESEAU,
      },
      reseau: [],
      categories: [
        CATEGORIE_REGROUPEMENT,
        CATEGORIE_REGROUPEMENT_LC,
        CATEGORIE_REGROUPEMENT_MAIRIE,
        CATEGORIE_REGROUPEMENT_NUMERIQUE,
      ],
    };
  },
  components: {
    breadcrumb,
    storeRechercheProvider,
    listeReseaux,
  },
  computed: {
    ...Audit.mapGetters({
      audit: 'auditCourant',
    }),
    breadcrumb() {
      const output = [
        { title: this.$i18n.t('general.breadcrumb.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$i18n.t('addEditAudit.breadcrumb.liste'), route: { name: 'l.logistique.ordre_travail_audit' }, isActive: false },
        { title: this.$i18n.t('addEditAudit.breadcrumb.add'), route: { name: 'm.logistique.ordre_travail_audit-add' }, isActive: false },
        { title: this.$i18n.t('addEditAudit.breadcrumb.addReseau'), route: '', isActive: true },
      ];
      if (this.audit?.id) {
        output[2].title = this.$i18n.t('addEditAudit.breadcrumb.edit');
        output[2].route = { name: 'm.logistique.ordre_travail_audit-edit', params: { id: this.audit.id } };
      }
      return output;
    },
    getDispositifsAssociated() {
      return this.audit?.otPatrimoine
        .otsAuditEnfants.map(otsAuditEnfant => otsAuditEnfant.otPatrimoine.dispositif);
    },
  },
  methods: {
    ...Audit.mapMutations({
      setAudit: SET_AUDIT_COURANT,
    }),
    getFormatedDateVisualisation() {
      const date = this.$store.getters['reseauAudit/criteresRecherche']?.dateVisualisation;
      if (date) {
        return formatDate(date);
      }
      return formatDate(new Date());
    },
    addSelect(value) {
      this.reseau = this.reseau.concat(value);
    },
    removeSelect(value) {
      this.reseau = this.reseau.filter(r => !value.map(v => v.id).includes(r.id));
    },
    async saveDispositif() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        if (this.reseau.length === 0) return;
        const payload = {
          reseauxIds: this.reseau.map(r => r.id),
          dateVisualisation: this.getFormatedDateVisualisation(),
        };
        const dispositifs = (await getAllDispositifFromReseau(payload)).data.result;
        this.audit.otPatrimoine.otsAuditEnfants = addGenerationOtFromDispositifAudit(
          dispositifs, this.audit.otPatrimoine.otsAuditEnfants,
        );
        await this.setAudit(this.audit);
      } catch (e) {
        messageErreur(this.$i18n);
        throw e;
      } finally {
        loadingComponent.close();
        this.$router.go(-1);
      }
    },
  },
  mounted() {
    if (!this.audit) this.$router.go(-1);
    if (this.audit) {
      this.audit.isFromPatrimoine = true;
    }
  },
};

</script>
